import { ActionTypes } from '../../constants/ActionTypes';
import { ThemeSetting } from '../../constants/ThemeSetting';
import { ISettingsReducer } from '../../interfaces/InitialSettings';

const initialSettings: ISettingsReducer = {
  navStyle: ThemeSetting.NAV_STYLE_FIXED,
  layoutType: ThemeSetting.LAYOUT_TYPE_FULL,
  themeType: ThemeSetting.THEME_TYPE_SEMI_DARK,
  themeColor: ThemeSetting.THEME_COLOR,
  pathname: '/',
  width: window.innerWidth,
  isDirectionRTL: false,
  locale: {
    languageId: 'persian',
    locale: 'fa',
    name: 'فارسی',
    direction: 'rtl',
    icon: 'ir',
  },
};

const settings = (state = initialSettings, action: any) => {
  switch (action.type) {
    // case "@@router/LOCATION_CHANGE":
    //   return {
    //     ...state,
    //     pathname: action.payload.location.pathname,
    //   };

    case ActionTypes.WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };

    case ThemeSetting.THEME_TYPE:
      return {
        ...state,
        themeType: action.themeType,
      };

    case ThemeSetting.THEME_COLOR:
      return {
        ...state,
        themeColor: action.themeColor,
      };

    case ThemeSetting.NAV_STYLE:
      return {
        ...state,
        navStyle: action.navStyle,
      };

    case ThemeSetting.LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.layoutType,
      };

    case ActionTypes.SWITCH_LANGUAGE:
      return {
        ...state,
        locale: action.payload,
      };

    default:
      return state;
  }
};

export default settings;
